import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCrossSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cross-small, crossed small, delete, remove"} maskId="square-filled-radius-0-stroke-1-IconCrossSmall"><path fillRule="evenodd" clipRule="evenodd" d="M7.75003 6.33594L12 10.5859L16.25 6.33594L17.6642 7.75015L13.4142 12.0002L17.6642 16.2502L16.25 17.6644L12 13.4144L7.75003 17.6644L6.33582 16.2502L10.5858 12.0002L6.33582 7.75015L7.75003 6.33594Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCrossSmall;
